/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PagedResourcesUserDistribution } from '../../models/paged-resources-user-distribution';

export interface GetUserDistributions$Params {
  'Active-Tenant-Identifier': string;
  userId: string;
  page?: number;
  size?: number;
}

export function getUserDistributions(http: HttpClient, rootUrl: string, params: GetUserDistributions$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedResourcesUserDistribution>> {
  const rb = new RequestBuilder(rootUrl, getUserDistributions.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('userId', params.userId, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagedResourcesUserDistribution>;
    })
  );
}

getUserDistributions.PATH = '/users/{userId}/distributions';
